import Quill from 'quill';
import { VideoPronto } from '@services/video.service';

const BlockEmbed: any = Quill.import('blots/block/embed');

/** Le url arrivano dal nostro backend, ma il markup si costruisce comunque protetto. */
function protetto(valore: string): string {
  return String(valore)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/**
 * Markup del video dentro l'articolo.
 *
 * `preload="metadata"` scarica i primi byte e non il video: tre video in un
 * articolo altrimenti lo affossano. `width` e `height` sono le dimensioni vere
 * lette da ffprobe, e servono a due cose: non far saltare il layout quando il
 * video si carica, e permettere alla versione AMP di disegnarlo responsive,
 * cosa che senza rapporto d'aspetto non sa fare.
 */
export function markupVideo(video: VideoPronto): string {
  return (
    `<figure class="video-locale">` +
    `<video controls preload="metadata" playsinline poster="${protetto(video.poster)}" ` +
    `width="${Math.round(video.larghezza)}" height="${Math.round(video.altezza)}">` +
    `<source src="${protetto(video.url)}" type="video/mp4">` +
    `</video>` +
    `</figure>`
  );
}

export class EmbedVideoFile extends BlockEmbed {
  static blotName = 'embed-video-file';
  static tagName = 'DIV';
  static className = 'video-locale-wrapper';

  static create(value: VideoPronto) {
    const node = super.create();
    node.innerHTML = markupVideo(value);
    return node;
  }

  static value(domNode: any): VideoPronto | null {
    const video = domNode.querySelector('video');
    const source = domNode.querySelector('source');
    if (!video || !source) {
      return null;
    }
    return {
      url: source.getAttribute('src') || '',
      poster: video.getAttribute('poster') || '',
      durata: 0,
      larghezza: Number(video.getAttribute('width')) || 0,
      altezza: Number(video.getAttribute('height')) || 0,
    };
  }
}

Quill.register(EmbedVideoFile);
